import React from 'react';
import {styled} from '@mui/material/styles';
import Box from "@mui/material/Box";
import ImageIcon from "@mui/icons-material/Image";
import grey from "@mui/material/colors/grey";


const StyledBox = styled(Box)(({theme}) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledPlaceholderBox = styled(Box)(({theme}) => ({
    display: 'flex',
    height: 'auto',
    //height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledImageIcon = styled(ImageIcon)(({theme}) => ({
    width: '50%',
    height: '50%',
    color: grey[800],
}));

const StyledImg = styled('img')(({theme, mobile}) => ({
    maxWidth: '100%',
    maxHeight: mobile ? '100vh' : '100%',

}));


export default function PlaceholderImage({ src, alt }) {
    const [mobile,] = React.useState(window.innerWidth < 900);

    return (
        <StyledBox>
            {src === undefined &&
                <StyledPlaceholderBox>
                    <StyledImageIcon/>
                </StyledPlaceholderBox>
            }
            {src !== undefined &&
                <StyledImg src={src} alt={alt} id={'asdf.png'} mobile={mobile ? 1 : 0}/>
            }
        </StyledBox>
    );
}

Image.defaultProps = {
    src: undefined,
    alt: '',
};
